<template>
  <v-card
    :color="!isImpersonated ? 'primary' : 'secondary'"
    class="d-inline ma-0 pa-0"
  >
    <view-table ref="viewTable"></view-table>
    <v-card-text
      class="text-lg-left ma-0 pa-0"
      v-show="
        !['OrderApprove', 'OrderDocusign', 'DocusignSuccess'].includes(
          $route.name
        )
      "
    >
      <v-layout row wrap>
        <v-dialog
          v-if="environment == 'production'"
          scrollable
          :overlay="false"
          max-width="500px"
          transition="dialog-transition"
        >
          <v-btn slot="activator" color="primary" dark small>
            Remote Support
          </v-btn>
          <v-card>
            <iframe
              width="400px"
              height="150px"
              src="https://assist.zoho.com/login/embed-remote-support.jsp"
              frameborder="0"
            ></iframe>
          </v-card>
        </v-dialog>
        <v-btn
          v-if="!$auth.loading && !$auth.isAuthenticated"
          small
          @click="$auth.loginWithRedirect()"
        >
          Login
        </v-btn>

        <div v-if="$auth.isAuthenticated && !isImpersonated">
          <span
            class="text-muted font-weight-light px-2"
            style="color: #fff !important;"
          >
            {{ $auth.user.name }}
          </span>
          <v-btn small color="danger" v-on:click="logout">Logout</v-btn>
          <v-btn v-if="isAdmin" icon dark @click="viewAsTable">
            <v-icon>mdi-eye</v-icon>
          </v-btn>
        </div>

        <div v-else-if="$auth.isAuthenticated && isImpersonated">
          <span style="color: #fff !important;">
            Viewing as:
            {{
              imperson.impersonating.dealerFullName
                ? imperson.impersonating.dealerFullName
                : imperson.impersonating.name
            }}
          </span>
          <v-btn icon dark @click="toggleView">
            <v-icon>exit_to_app</v-icon>
          </v-btn>
        </div>
      </v-layout>
    </v-card-text>
    <v-dialog
    v-model="mfadialog"
    persistent
    max-width="500px"
    transition="dialog-transition"
  >
    <mfa-dialog @closeDialog="closeMFADialog"></mfa-dialog>
  </v-dialog>
  </v-card>
  
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import ViewTable from '@/components/common/ViewTable';
import MfaDialog from '@/components/EnrollMFADialog.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapImpersonateState } = createNamespacedHelpers(
  `impersonate`
);
const { mapGetters: mapFeatureFlagGetters } =
  createNamespacedHelpers(`orders/featureFlag`);


export default {
  name: 'AppHeader',
  components: {
    ViewTable,
    MfaDialog
  },
  data() {
    return {
      showDialog: false,
      impersonations: [],
      mfadialog:false,
    };
  },
  methods: {
    ...mapActions('impersonate', [
      'toggleViewBar',
      'setImpersonatingAs',
      'resetImpersonation',
      'processImpersonation',
      'getCurrentDealerCustomers',
      'getDealerMembers',
      'revokeImpersonation',
      'showLoading',
      'hideLoading',
    ]),

    logout() {
      this.$auth.logout({ returnTo: window.location.origin });
    },
    viewAsTable() {
      let vm = this;
      let ref = vm.$refs;

      this.showDialog = true;
      this.showLoading();
      ref.viewTable.toggleDisplay = true;
      ref.viewTable.addViews();
      this.hideLoading();
    },
    toggleView() {
      let vm = this;

      vm.revokeImpersonation().then(() => {
        vm.toggleViewBar();
        vm.resetImpersonation();
        window.location.href = '/';
      });
    },
    openMFADialog() {
      this.mfadialog = true;
    },
    closeMFADialog() {
      this.mfadialog = false;
    },
  },
  computed: {
    ...mapGetters(['viewbarEnabled', 'impersonating']),
    ...mapGetters('orders', ['isAdmin']),
    ...mapFeatureFlagGetters(['allFlags']),

    environment() {
      return process.env.NODE_ENV;
    },
    imperson() {
      return this.$store.state.impersonate;
    },
    isImpersonated() {
      return this.$store.state.impersonate.viewbarEnabled;
    },
  },
};
</script>
